import Vue from 'vue';
import Vuex from 'vuex';
import { auth, db, storage } from '../assets/js/firebase/db.js';
import { MessageBox } from 'element-ui';
import moment from 'moment';
import { getBase64ImageFromURL } from '../assets/js/helpers/uriEncoder';
import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket';

// let storage = firebase.storage();

Vue.use(Vuex);
const logrocketPlugin = createPlugin(LogRocket);

export const store = new Vuex.Store({
  plugins: [logrocketPlugin],
  state: {
    count: 0,
    totalHours: 0,
    regularHours: 0,
    otHours: 0,
    travelHours: 0,
    stat: 0,
    onCallHours: 0,
    authState: false,
    currentUser: null,
    userName: null,
    userEmail: null,
    userCompany: null,
    userCompanyName: null,
    timeCardRounding: null,
    showIncompleteTimeCards: null,
    showOnCallNotification: null,
    showInactiveEmployees: null,
    requireEditComments: null,
    encodedLogo: null,
    logoUrl: null,
    allEmployeeStatHours: [],
    companyFiveOfNine: null,
    statCountsOTExempt: null,
    jobSpecificTimes: null,
    jobs: [],
    timeCardUpdated: false,
    timeRunning: false,
    elapsedTime: 0,
    allowNotifications: null
  },
  getters: {
    timeCardRounding: state => state.timeCardRounding
  },
  mutations: {
    updateTotals(state, { total, reg, ot, travel, onCall }) {
      state.totalHours += parseFloat(total);
      state.regularHours += parseFloat(reg);
      state.otHours += parseFloat(ot);
      state.travelHours += parseFloat(travel);
      state.onCallHours += parseFloat(onCall);
    },
    clearTotals(state) {
      state.totalHours = 0;
      state.regularHours = 0;
      state.otHours = 0;
      state.travelHours = 0;
      state.onCallHours = 0;
    },
    updateAuth(state, { value, company }) {
      state.authState = value;
      state.currentUser = auth.currentUser;
      state.userName = auth.currentUser.displayName;
      state.userEmail = auth.currentUser.email;
      state.userCompany = company;
    },
    updateCompany(state, { company }) {
      state.userCompanyName = company;
    },
    updateCompanySettings(
      state,
      {
        rounding,
        incomplete,
        oncall,
        inactiveEmployees,
        editComments,
        fiveOfNine,
        statCountsOTExempt,
        jobSpecificTimes,
        notificationAllowed
      }
    ) {
      state.timeCardRounding = rounding;
      state.showIncompleteTimeCards = incomplete;
      state.showOnCallNotification = oncall;
      state.showInactiveEmployees = inactiveEmployees;
      state.requireEditComments = editComments;
      state.companyFiveOfNine = fiveOfNine;
      state.statCountsOTExempt = statCountsOTExempt;
      state.jobSpecificTimes = jobSpecificTimes === 'Yes' ? true : false;
      state.allowNotifications = notificationAllowed;
    },
    updateJobs(state, jobs) {
      state.jobs = jobs;
    },
    updateEmployeeStatTime(state, { employee, time, date }) {
      //checks if the employee already has an object in the array for that date and does not add it if it does
      if (
        !state.allEmployeeStatHours.some(
          e => e.date === date && e.name === employee
        )
      ) {
        state.allEmployeeStatHours.push({
          name: employee,
          stat: time,
          date: date
        });
      }
    },
    clearEmployeeStatTime(state) {
      state.allEmployeeStatHours = [];
    },
    updateLogoMetaData(state, { url, base64 }) {
      state.logoUrl = url;
      state.encodedLogo = base64;
    },
    clearLogoMetaData(state) {
      state.logoUrl = null;
      state.encodedLogo = null;
    },
    SetTimeCardUpdated(state, value) {
      state.timeCardUpdated = value;
    },
    SET_ELAPSED_TIME(state, payload) {
      state.elapsedTime = payload;
    }
  },
  actions: {
    setTimeCardUpdated({ commit }, value) {
      commit('SetTimeCardUpdated', value);
    },
    setElapsedTime({ commit }, payload) {
      commit('SET_ELAPSED_TIME', payload);
    }
  }
});

auth.onAuthStateChanged(async user => {
  //TODO: Check if the user that logged in is an admin user. If they are not, send them to the 404 page.

  if (user != null) {
    db.collection('users')
      .doc(user.uid)
      .get()
      .then(doc => {
        //check to see if the user is an admin user and if they are allowed to access the portal.
        if (doc.data().roles[0] == 'admin') {
          store.commit('updateAuth', {
            value: true,
            company: doc.data().company
          });
          LogRocket.identify(auth.currentUser.uid, {
            name: doc.data().name,
            email: doc.data().email,
            // Add your own custom user variables here, ie:
            // subscriptionType: 'pro'
          });
          db.collection('companies')
            .doc(doc.data().company)
            .get()
            .then(company => {
              store.commit('updateCompany', {
                company: company.data().companyName
              });
            })
            .catch(err => {
              console.log('Error getting user company');
            });
          db.collection('companySettings')
            .where('company', '==', doc.data().company)
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(settings => {
                store.commit('updateCompanySettings', {
                  rounding: settings.data().timeCardRounding,
                  incomplete: settings.data().showIncompleteTimeCards,
                  oncall: settings.data().showOnCallNotification,
                  inactiveEmployees: settings.data().showInactiveEmployees,
                  editComments:
                    settings.data().editComments == undefined
                      ? 'Yes'
                      : settings.data().editComments,
                  fiveOfNine: settings.data().fiveOfNine,
                  statCountsOTExempt: settings.data().statCountsOTExempt,
                  jobSpecificTimes: settings.data().jobSpecificTimes,
                  notificationAllowed: settings.data().allowNotifications
                });
              });

              if (
                store.state.showOnCallNotification == 'Yes' &&
                (moment().day() == 1 || moment().day() == 2)
              ) {
                //show the on call popup if the setting is active and the day is monday or tuesday
                MessageBox.alert(`Create on call time cards`, 'Reminder', {
                  confirmButtonText: 'OK',
                  type: 'info'
                });
              }

              if (store.state.jobSpecificTimes) {
                let jobs = [];
                db.collection('jobs')
                  .where('org', '==', store.state.userCompany)
                  .where('deleted', '==', false)
                  .get()
                  .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                      let index = jobs.push(doc.data());
                      jobs[index - 1]['id'] = doc.id;
                    });
                    store.commit('updateJobs', jobs);
                  })
                  .catch(err => {
                    console.log(`Error getting jobs: ${err}`);
                    this.showError('Error getting jobs');
                  });
              }
            })
            .catch(err => {
              console.log(`Error getting company settings ${err}`);
            });

          try {
            //get the company logo.
            let storageRef = storage.ref(`logos/${doc.data().company}`);
            console.log(storageRef);
            storageRef
              .getDownloadURL()
              .then(url => {
                getBase64ImageFromURL(url)
                  .then(resp => {
                    store.commit('updateLogoMetaData', {
                      url: url,
                      base64: resp
                    });
                  })
                  .catch(urlErr => {
                    console.log('Error retrieving company logo');
                  });
              })
              .catch(err => {
                console.log('Error getting company logo');
              });
          } catch (err) {
            console.log('Error getting company logo');
          }
        } else {
          console.log('Access denied.');
        }
      });
  } else {
    store.commit('updateAuth', { value: false });
  }
});
